import type { HTMLAttributes } from 'react';
import css from './ServiceBackground.module.css';

const bgTile = '/img/bg_tile.png';

interface ServiceBackgroundProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export function ServiceBackground({ children, className, style, ...props }: ServiceBackgroundProps) {
  return (
    <div
      className={[css.serviceBackground, className].filter(Boolean).join(' ')}
      style={{ backgroundImage: `url(${bgTile})`, ...style }}
      {...props}
    >
      {children}
    </div>
  );
}
